site.extendedmenu = {
	init: function() {
		$(window).on('resize', function() {
			site.extendedmenu.splitMenu();
		});
		site.extendedmenu.splitMenu();
	},

	splitMenu: function() {
		var $body = $('body'),
			mainmenu = $('#mainmenu'),
			nodes = mainmenu.find('li'),
			mmWidth = mainmenu.width(),
			totalWidth = 0,
			extendedMenu = $('.extendedMenu');
		extendedMenu.remove();
		nodes.removeClass('extended');
		nodes.each(function() {
			if (!$(this).is('.fullscreenMenuOnly') && !$(this).is('.navbutton')) {
				totalWidth += $(this)[0].scrollWidth;
				if (totalWidth >= mmWidth - 50) {
					if (!$('.extendedMenu').length) {
						mainmenu.after('<div class="extendedMenu"><ul class="menu mmLevel1"></ul></div>');
					}
					$('.extendedMenu ul').append($(this)[0].outerHTML);
					$(this).addClass('extended');
				}
			}
		});
		$body.removeClass('menuIsExtended');
		if ($('.level1.extended').length) {
			$body.addClass('menuIsExtended');
		}
		$('.extendedMenu').hover(function() {
			$('#mainmenu').addClass('hover');
		}, function() {
			$('#mainmenu').removeClass('hover');
		});

		var level1 = $('#mainmenu a, .extendedMenu a');
		level1.focus(function() {
			$('#mainmenu').addClass('hover');
		});
		level1.blur(function() {
			$('#mainmenu').removeClass('hover');
		});

	}
};
site.inits.push('site.extendedmenu.init()');
